import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-live_view_select_down",
  "use": "icon-live_view_select_down-usage",
  "viewBox": "0 0 11 5.511",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 5.511\" id=\"icon-live_view_select_down\">\r\n  <path id=\"icon-live_view_select_down_下\" class=\"cls-1\" d=\"M71.161,283.56l4.848-4.267a.6.6,0,0,0,.038-.878.659.659,0,0,0-.913-.036l-4.414,3.885-4.42-3.891a.665.665,0,0,0-.913.042.6.6,0,0,0,.044.878l4.854,4.261c.013.006.019.018.031.024A.654.654,0,0,0,71.161,283.56Z\" transform=\"translate(-65.22 -278.212)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol